import { PageHero } from '../components/ui/PageHero';
import { AnimatedCard } from '../components/ui/AnimatedCard';
import { CTAButton } from '../components/ui/CTAButton';
import { SectionLink } from '../components/ui/SectionLink';
import { APP_CAPABILITIES, FEATURES } from '../constants/content';
import { featurePath } from '../constants/navigation';

export default function FeaturesPage() {
  return (
    <>
      <PageHero
        title="全维度冥想指引"
        subtitle="选择对应主题，即刻获取专属引导课程与练习建议。每个领域配备定制化冥想方案与 AI 陪伴。"
        breadcrumb={[{ label: '首页', path: '/' }, { label: '功能特色' }]}
      />

      <section className="container mx-auto px-4 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto mb-16">
          {FEATURES.map((feature) => (
            <AnimatedCard
              key={feature.id}
              className={`bg-white/5 backdrop-blur-sm rounded-2xl p-8 border border-purple-500/20 ${
                feature.highlight ? 'ring-2 ring-purple-500/50' : ''
              }`}
            >
              <div
                className={`w-12 h-12 rounded-xl ${feature.iconBg} flex items-center justify-center mb-4`}
              >
                <i className={`fa ${feature.icon} ${feature.iconColor} text-xl`} />
              </div>
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-purple-200 text-sm mb-3">{feature.desc}</p>
              <p className="text-purple-300 text-sm mb-4 leading-relaxed line-clamp-3">
                {feature.detail}
              </p>
              <ul className="text-purple-300 text-xs space-y-1 mb-4">
                {feature.items.map((item) => (
                  <li key={item}>· {item}</li>
                ))}
              </ul>
              <p className="text-purple-400 text-xs mb-4">
                推荐课程：{feature.meditations.join('、')}
              </p>
              <SectionLink to={featurePath(feature.id)}>查看完整介绍</SectionLink>
            </AnimatedCard>
          ))}
        </div>

        <div className="bg-white/5 rounded-3xl border border-purple-500/20 p-8 md:p-10 max-w-5xl mx-auto mb-16">
          <h2 className="text-2xl font-bold text-center mb-8">APP 核心能力</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {APP_CAPABILITIES.map((cap) => (
              <div key={cap.title} className="flex items-start gap-3">
                <i className={`fa ${cap.icon || 'fa-check-circle'} text-secondary mt-1`} />
                <div>
                  <p className="font-medium">{cap.title}</p>
                  <p className="text-purple-300 text-sm">{cap.desc}</p>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div className="max-w-3xl mx-auto bg-gradient-to-r from-primary/10 to-pink-500/10 rounded-2xl p-8 border border-purple-500/20 text-center">
          <h3 className="text-xl font-semibold mb-4">准备好开始了吗？</h3>
          <p className="text-purple-200 text-sm mb-6">
            下载 APP，选择你需要的主题，从 5 分钟呼吸冥想开始。
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <CTAButton to="/guide" variant="primary" icon="fa-play">
              查看使用教程
            </CTAButton>
            <CTAButton to="/meditation" variant="secondary">
              了解冥想课程
            </CTAButton>
          </div>
        </div>
      </section>
    </>
  );
}
